// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1ikwP","tab":"ProcedureTabs_tab__1taRK"};